/**
 * Hard route swap — no view-enter animation, no slide.
 *
 * We used to fade + slide-up on every route change. On mobile that reads as
 * "flopping / unstable" because native mobile apps swap views instantly.
 * Kept as a component (not deleted) so the AppShell wrapper stays intact
 * and we can re-introduce a <120ms opacity swap later if design wants it.
 */
export default function PageTransition({ children }) {
  return children;
}
